module.exports = __webpack_public_path__ + "img/success.cefc4018.svg";